/**
 * ExecutiveDarkController — POC V2.
 *
 * A differenza del V1 (che avvolgeva 3 pagine), questo controller applica
 * l'attributo `data-executive-dark` a `document.documentElement` così il tema
 * copre INTERA SHELL dell'app (sidebar + topbar + content + banner + trial bar)
 * e appare come un unico prodotto.
 *
 * VINCOLO invariato: nessuna modifica a dati/API/logic. Solo CSS scoped.
 *
 * Attivazione:
 *   URL param  ?theme=executive-dark
 *   localStorage.cx.exec_dark_preview = "1"
 *
 * Disattivazione: click su toggle floating oppure ?theme=light.
 */
import React, { useEffect, useState, useCallback } from "react";
import "../../styles/executive-dark-preview.css";

const STORAGE_KEY = "cx.exec_dark_preview";

function readInitial() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("theme") === "executive-dark") {
      window.localStorage.setItem(STORAGE_KEY, "1");
      return true;
    }
    if (params.get("theme") === "light") {
      window.localStorage.setItem(STORAGE_KEY, "0");
      return false;
    }
    const stored = window.localStorage.getItem(STORAGE_KEY);
    // Default: Pearl Grey Premium ON.
    // Se localStorage non è mai stato scritto, applichiamo il tema brand
    // di default. Solo un valore esplicito "0" (disattivato dall'utente)
    // lo tiene spento.
    if (stored === null || stored === undefined) return true;
    return stored === "1";
  } catch (_) {
    return true;
  }
}

function applyGlobal(on) {
  try {
    const root = document.documentElement;
    if (on) {
      root.setAttribute("data-executive-dark", "true");
      root.style.colorScheme = "dark";
    } else {
      root.removeAttribute("data-executive-dark");
      root.style.colorScheme = "";
    }
  } catch (_) {
    /* ssr safety */
  }
}

export default function ExecutiveDarkController() {
  const [on, setOn] = useState(() => readInitial());

  useEffect(() => {
    applyGlobal(on);
  }, [on]);

  const toggle = useCallback(() => {
    const next = !on;
    setOn(next);
    try {
      // Persistiamo sempre il valore esplicito: "1" attivo, "0" spento.
      // Solo il valore ESPLICITAMENTE "0" tiene il tema spento
      // (default se localStorage non ha nulla = ON).
      window.localStorage.setItem(STORAGE_KEY, next ? "1" : "0");
    } catch (_) {
      /* ignore */
    }
  }, [on]);

  return (
    <button
      type="button"
      onClick={toggle}
      className={`exd-toggle ${on ? "" : "exd-off"}`}
      title="Toggle Executive Dark Preview (POC V2)"
      data-testid="executive-dark-toggle"
    >
      {on ? "◐ Pearl Grey Premium · click per Light" : "◑ Anteprima Pearl Grey Premium"}
    </button>
  );
}

// Backwards-compat wrapper: se qualche pagina importa ancora ExecutiveDarkWrapper
// come default, restituisce solo i children (il theming avviene ora a livello globale).
export function ExecutiveDarkWrapper({ children }) {
  return <>{children}</>;
}
